export enum Incoterms {

	EXW = "EXW", FCA = "FCA", FAS = "FAS", FOB = "FOB", CFR = "CFR", CIF = "CIF", CPT = "CPT", CIP = "CIP", DPU = "DPU", DAP = "DAP", DDP = "DDP", none = "none"

}
